export const GET_MOBILES_REQUEST = "GET_MOBILES_REQUEST";
export const GET_MOBILES_SUCCESS = "GET_MOBILES_SUCCESS";
export const GET_MOBILES_FAILURE = "GET_MOBILES_FAILURE";